/* src/app/intern/mentor-contacts/mentor-contacts.component.scss */
.loadingSpinner {
  width: 150px;
  margin: auto;
}
.card-actions {
  width: 100%;
  text-align: right;
}
/*# sourceMappingURL=mentor-contacts.component.css.map */
